import { isValidPhoneNumber } from 'react-phone-number-input';

import errorMessages from '../data/error-messages';

export function phoneNumberValidator(phone: string) {
  return isValidPhoneNumber(phone) ? undefined : errorMessages.phone;
}
